import OpenAI from "openai";
import { useEffect, useRef, useState } from "react";
import {GridLoader} from 'react-spinners'
import { IoSendSharp } from "react-icons/io5";
import logo from '../../../../assets/images/logo.webp'
import { useNavigate } from "react-router-dom";
import { socials } from "../../../../links";

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_AI_API_KEY,
  organization: process.env.REACT_APP_AI_ORGANAZATION,
  dangerouslyAllowBrowser: true
});


const RaydiumAiAgent = () => {

const constructData = `
you are a proffesional trader helping other traders to make decision and provide opinion about based on this data


`

  
const AiData = ''

  const [isTyping, setIsTyping] = useState(false); // State to indicate typing status
  const [userInput, setUserInput] = useState(null); // State for user input
  const [messages, setMessages] = useState([
    {
      role: "system",
      content:AiData
    },
    {
      role: "assistant",
      content: "Do you want help in this Token ?",
    },
  ]);
  
  const navigate = useNavigate()
  const chatContainerRef = useRef(null); // Reference for the last message container
  useEffect(() => {
    // Scroll to the bottom every time messages change
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }

  }, [messages]);

  async function sendMessage() {
    if (!userInput.trim()) return; // Prevent empty messages
    // Add the user message to the chat history
    const userMessage = { role: "user", content: userInput };
    setMessages((prev) => [...prev, userMessage]);
    setUserInput(""); // Clear input field
    setIsTyping(true);

    let botMessage = { role: "assistant", content: "", complete: false };

    // Add the initial assistant message only once
    setMessages((prev) => [...prev, botMessage]);

    const stream = await openai.chat.completions.create({
      model: "gpt-3.5-turbo",
      messages: [...messages, userMessage], // Include conversation history
      stream: true,
    });

    let botMessageContent = ""; // Variable to hold the full content of the bot message

    for await (const chunk of stream) {
      const content = chunk.choices[0]?.delta.content || "";
      // Append only the new content from the current chunk
      botMessageContent += content;
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;

        if (updated[lastIndex]?.role === "assistant") {
          updated[lastIndex].content = botMessageContent; // Update the last assistant message
        }
        return updated;
      });
    }
    handleCustomEvent(botMessageContent)
    console.log(botMessageContent)
    // Mark the assistant message as complete
    setMessages((prev) =>
      prev.map((msg, index) =>
        index === prev.length - 1 && msg.role === "assistant"
    ? { ...msg, complete: true }
    : msg
  )
);

setIsTyping(false); // Typing finished
}

  function onEnterPress(e) {
    setUserInput(null)
    if (e.keyCode == 13 && e.shiftKey == false) {
      e.preventDefault();
      sendMessage()
    }
  }

  const handleCustomEvent = (message) => {
    if (message.includes("Navigate to the whitelist page")) {

      setTimeout(()=>navigate('/whitelist'),1000)
      // Trigger a contact form on your website
    }  if (message.toLowerCase().includes ("navigate to telegram") ){
      let openLink = window.open(socials.tg,'_blank');

      setTimeout(()=>openLink ,1000)

    }
  };


  const renderMessageContent = (content) => {
    const markdownLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/g;
    const imageRegex = /(https?:\/\/.*\.(?:png|jpg|jpeg|gif))/g;
  
    // Replace Markdown-style links and image URLs
    const processedContent = content.split(markdownLinkRegex).map((segment, index) => {
      // If the segment matches an image URL
      if (imageRegex.test(segment)) {
        return (
          <img
            key={index}
            src={segment}
            alt="AI-generated"
            className="max-w-full h-auto rounded-lg my-2"
          />
        );
      }
  
      // If the segment matches a Markdown link
      if (index % 3 === 1) {
        // Markdown link has format: [text](url)
        const linkText = segment;
        const url = content.split(markdownLinkRegex)[index + 1]; // URL follows the text
        return (
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            {linkText}
          </a>
        );
      }
  
      // Otherwise, return the plain text
      return <span key={index}>{segment}</span>;
    });
  
    return processedContent;
  };
  


  return (

    <div className=" mx-auto  bg-white/5 rounded-xl shadow-xl backdrop-blur overflow-hidden  min-w-[250px] max-w-[550px] ">
      <div className=' p-5 relative  max-h-[400px] overflow-y-auto ' ref={chatContainerRef}>
        <div className="w-full  flex flex-col items-between h-full">
          <div  className="flex-1 overflow-y-auto p-3 space-y-3 w-[100%]">
            {
              messages.map((msg, index) => (
                msg.role !== "system" && <div key={index} className={`flex items-center ${msg.role === "user" ? "justify-end" : "justify-start"} mb-2`}>
                  <p className={`p-2 px-5 rounded-lg max-w-[90%] text-sm ${msg.role === "user" ? "bg-orange-500/20 text-white" : " text-neutral-200 bg-white/5 text-left flex justify-start items-start gap-2"}`}>
                    {msg.role !== "user" && <img src={logo} alt="" className='w-6 h-6 p-1 rounded-full bg-neutral-100/10' />}
                   <div className="flex gap-5 flex-wrap">
                    {  renderMessageContent(msg.content)}
                   </div>
                  </p>
                </div>
              ))
            }
          </div>
          <div className="h-max absolute top-[40%] left-[40%] ">
            {isTyping &&
              <GridLoader
                color="#ff8a00" />
            }
          </div>
        </div>
      </div>
        <div className="flex items-center justify-center w-full gap-5 bg-white/10  p-2 h-20 shadow-xl">
          <textarea onKeyDown={(e) => onEnterPress(e)} value={userInput} placeholder="Message Phoenix AI " onChange={(e) => setUserInput(e.target.value)}
            className="w-full p-2 text-white bg-transparent outline-none caret-orange-500  " name="" rows={2} cols={3} id=""></textarea>
          <button disabled={!userInput && true} onClick={() => sendMessage()} className="bg-orange-500 disabled:bg-neutral-400 p-2 flex items-center justify-center text-center rounded-full "><IoSendSharp className="h-5 w-5 text-white  " /></button>
        </div>
    </div>
  )
}

export default RaydiumAiAgent